import AppImage from '@/components/ui/AppImage';
 import Icon from'@/components/ui/AppIcon';

interface ProjectCardProps {
  title: string
  location: string
  challenge: string
  solution: string
  timeline: string
  image: string
  imageAlt: string
  delay?: number
}

export default function ProjectCard({ 
  title, 
  location, 
  challenge, 
  solution, 
  timeline,
  image,
  imageAlt,
  delay = 0 
}: ProjectCardProps) {
  return (
    <div 
      className="group border-b border-border hover:bg-card transition-all duration-500 reveal"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 min-h-[300px]">
        {/* Content */}
        <div className="col-span-1 md:col-span-5 p-8 md:p-12 border-r border-border/0 md:border-border flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-4">
            <Icon 
              name="MapPinIcon"
              size={20}
              className="text-primary"
            />
            <span className="text-sm font-mono text-muted-foreground">{location}</span>
          </div>
          
          <h3 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground group-hover:text-primary transition-colors">
            {title}
          </h3>
          
          <div className="space-y-3 mb-6">
            <div>
              <h4 className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-1">
                Challenge
              </h4>
              <p className="text-sm text-muted-foreground leading-relaxed">{challenge}</p>
            </div>
            
            <div>
              <h4 className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-1">
                Solution
              </h4>
              <p className="text-sm text-muted-foreground leading-relaxed">{solution}</p>
            </div>
          </div>
          
        </div>
        
        {/* Image */}
        <div className="col-span-1 md:col-span-7 relative overflow-hidden min-h-[300px]">
          <div className="absolute inset-0 bg-muted flex items-center justify-center p-8">
            <AppImage 
              src={image}
              alt={imageAlt}
              className="w-full h-full object-cover grayscale-image group-hover:scale-105 transition-all duration-700"
            />
          </div>
        </div>
      </div>
    </div>
  )
}